import * as React from 'react';
import { useStoreActions } from 'easy-peasy';
import DoneIcon from '@mui/icons-material/Done';
import { Post } from '../../services/http';

export default function MissionHebrewPage() {
  const [campaigns, setCampaigns] = React.useState(false);
  const openInfoPopup = useStoreActions((actions) => actions.open);

  const send = async () => {
    const fromName = document.getElementById('fromName').value;
    const fromEmail = document.getElementById('fromEmail').value;
    const phone = document.getElementById('phone').value;
    const content = document.getElementById('content').value;
    console.log('fromName', fromName);
    const result = await Post('/api/donation/CreateContactUsItem', { fromName, fromEmail, phone, content });
    console.log('result', result);
    if (result.result) {
      openInfoPopup({ notice: 'הפניה נשלחה בהצלחה', reload: false });
    } else {
      openInfoPopup({ notice: result.message, reload: false });
    }
  };

  return (
    <main className="main text-page" dir="rtl">
      <section className="head-section" style={{ backgroundImage: 'url(/img/backgroundImage.png)' }}>
        <h1 className="text-center-bg head-section__title _anim-items _anim-no-hide _fadeDown color-2 weight-60 font-70 f-normal" data-animate-delay="02">
          למה אנחנו?
          <p className="mb-0 f-16 text-white mt-20 f-normal">
            <span className="color-3">למה אנחנו?</span> {'<<'}   Main
          </p>
        </h1>
      </section>
      <div class="container">
        <div className="form-section _anim-items _fadeUp" data-animate-delay="02">
          <p class="title weight-700 color-1 roboto f-normal f-40">התמורה:</p>
          <br />
          <p className="center-text weight-600 f-24 roboto f-normal">
            בסכום סמלי של 28 דולר לחודש בלבד
            <br />
            תוכלו גם אתם להגיע ללב ליבו של התורם הפונטציאלי.
          </p>
          <p class="text-justify weight-600 f-20 lh-25 mb-0 color-4 rubik">
            לא. מעתה אין צורך במערכת קשרים מסועפת עם משרד יחסי ציבור בארצות הברית.
            &nbsp;
            <strong>
              אין גם צורך באנשי
              קשר
            </strong>&nbsp;
            שיעבדו בשבילכם בארצות הברית.
            <br />
            <strong style={{ color: '#1979be' }}>
              המערכת שלנו עושה בשבילכם את כל העבודה.
            </strong>
            <br />
            <br />
            <div>
              מעתה, גם אם אין לכם מוסד בעל שם עולמי, גם אם אינכם מוכרים היטב בבתי הגבירים הנודעים של אמריקה
              תוכלו להתנהל באמצעותנו כמוסדות הוותיקים והמוכרים שלהם יכולת גביה ופרסום רב.
            </div>
            <br />
            <br />
            <strong>
              בסכום סמלי זה של 28 דולרים לחודש תקבלו דף קבוע במערכת האינטרנטית עם לינק מסודר
            </strong>&nbsp;
            <div>
              שיופנה ישר לחשבון הבנק שלכם, או לכל מערכת מסודרת שתמצאו לנכון להפנות את התרומות המיועדות
              אליכם.
            </div>
            <div>
              ניתן להעביר את הכסף לארץ בעלות בסיסית (3% בלבד)
            </div>
          </p>
        </div>
        <br />
        <div className="form-section _anim-items _fadeUp" data-animate-delay="02">
          <p class="center weight-700 color-1 roboto f-normal f-40">אפשרויות התרומה:</p>
          <div class="align-center flex">
            <DoneIcon style={{ marginLeft: 5, padding: 5, color: '#FF5442', borderRadius: '50%', fontSize: 20, border: '1px solid #FF5442' }} />
            <p className="weight-400 f-20 color-4 mb-0 rubik">
              כרטיס אשראי וACH ,פייפל
            </p>
          </div>
          <div class="align-center flex">
            <DoneIcon style={{ marginLeft: 5, padding: 5, color: '#FF5442', borderRadius: '50%', fontSize: 20, border: '1px solid #FF5442' }} />
            <p className="weight-400 f-20 color-4 mb-0 rubik">   כמו כן, ניתנת אפשרות לתרום באמצעות מספר חיובים (הוראות קבע).</p>
          </div>
        </div>
        <div className="form-section _anim-items _fadeUp" data-animate-delay="02">
          <div class="title weight-700 roboto f-40">אמינות ללא פשרות:</div>
          <div class="flex ">
            <DoneIcon style={{ marginLeft: 5, padding: 5, color: '#FF5442', borderRadius: '50%', fontSize: 20, border: '1px solid #FF5442' }} />
            <p className="mb-0 roboto f-normal f-20 weight-500 text-justify color-4">
              המערכת החדשנית והאמינה
              <strong> מאפשרת לכם לדעת און ליין מה מצב חשבונכם, </strong>
              כשרק לכם קיימת היכולת
              לעקוב אחר התרומות, הן המיידיות והן העתידיות המופנות עבורכם.
            </p>

          </div>
          <div class="flex">
            <DoneIcon style={{ marginLeft: 5, padding: 5, color: '#FF5442', borderRadius: '50%', fontSize: 20, border: '1px solid #FF5442' }} />
            <p className="text-justify roboto f-normal f-20 weight-400 color-4">
              בנוסף,&nbsp;
              <span className="weight-600">כל תרומה מתעדכנת מיד בחשבון ומתקבל אימייל ישירות אליכם.</span><br />
              בחשבון תקבלו מידע מפורט על כל פרטי התרומה לרבות שם התורם (במידה והתורם לא ביקש להשאר
              אנונימי), צורת התרומה, ומתי היא תהיה זמינה למשיכה.
            </p>

          </div>
          <div class="flex">
            <DoneIcon style={{ marginLeft: 5, padding: 5, color: '#FF5442', borderRadius: '50%', fontSize: 20, border: '1px solid #FF5442' }} />
            <p className="text-justify roboto f-normal f-20 weight-400 color-4">
              <span className="weight-600">בלינק שלכם ניתן להכניס:</span><br />
              תמונות, סרטונים, כתבה על הארגון, זמן לקמפיין, הצעות לתרומה, וכדו.
              <br />כמו כן, ניתן לערוך קמפיין בעלויות שוק.
            </p>
          </div>
          <br />
          <p className="roboto weight-700 f-24 center-text" style={{ marginBottom: '50px' }}>יודגש כי אין עמלות מעבר לעלות אשראי ועיבוד בסיסיים, כאשר התורם יכול לכסות אף את העמלה הבסיסית.
            <br />למותר  לציין כי ארגוננו מוכר לצרכי מס והתורם מקבל קבלה אוטומטית לתיבת הדואר <br /> האלקטרוני.
          </p>
        </div>
      </div>
    </main>
  );
}
